
import { Options, Vue } from "vue-class-component";
import { PropType } from "vue";
import IXdrToken from "@/entities/IXdrToken";

@Options({
  props: {
    transactionFee: {
      type: Object as PropType<IXdrToken>,
      required: true,
    },
    showActions: {
      type: Boolean,
      default: false,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
  },
  emits: ["fund"],
})
export default class FeeBalanceInfo extends Vue {}
